/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment } from "react";
import { Link } from "react-router-dom";

export function BreadCrumbs({ items }) {
  if (!items || !items.length) {
    return "";
  }

  return (
    <ul className="breadcrumb breadcrumb-transparent font-weight-bold p-0 my-2">
      {items.map((item, index) => (
        <Fragment key={index}>
          {index > 0 && (
            <li key={`bc-separator-${index}`} className="breadcrumb-separator">
              &gt;
            </li>
          )}
          <li key={`bc${index}`} className="breadcrumbs-item font-md">
            <Link className="text-muted" to={{ pathname: item?.pathname }}>
              {index === items.length - 1 ? <span className="breadcrumb-child">{item.title}</span> : item.title}
            </Link>
          </li>
        </Fragment>
      ))}
    </ul>
  );
}
